<template>
  <div class="test-reports" v-loading="loading">
    <div class="page-title mb-30">Test Reports</div>
    <div class="page-content max-w-900">
      <el-form v-model="form" label-width="95px" size="mini" class="mb-30">
        <el-row :gutter="70">
          <el-col :xs="24" :sm="12">
            <el-form-item label="Pod SN / MAC">
              <el-select v-model="form.podMac" filterable clearable>
                <el-option
                  v-for="(item, index) in pods"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Tested by">
              <el-select v-model="form.testedBy" filterable clearable>
                <el-option
                  v-for="(item, index) in testers"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-row>
              <el-col :span="12">
                <el-form-item label="HW ver">
                  <el-select v-model="form.hwVer" filterable clearable>
                    <el-option
                      v-for="(item, index) in hwVersion"
                      :key="index"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="FW ver">
                  <el-select v-model="form.fwVer" filterable clearable>
                    <el-option
                      v-for="(item, index) in fwVersion"
                      :key="index"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Man. date">
              <el-date-picker
                class="wp-100"
                v-model="form.date"
                type="daterange"
                format="dd/MM/yy"
                value-format="yyyy-MM-dd"
                range-separator="to"
                start-placeholder="Start Date"
                end-placeholder="End Date"
                :picker-options="timeChange"
                :unlink-panels="true"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Asset Number">
              <el-select v-model="form.assetNumber" filterable clearable>
                <el-option
                  v-for="(item, index) in assetNumberOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Test Results" class="test-result">
              <el-radio-group v-model="form.result">
                <el-radio
                  v-for="(item, index) in testResultsOptions"
                  :key="index"
                  :label="item"
                  >{{ item }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :xs="24" class="text-right">
            <el-button
              class="cancel-btn mini-btn min-w-80 mr-15"
              @click="clearForm()"
              >Clear</el-button
            >
            <el-button class="cancel-btn mini-btn min-w-80" @click="getData()"
              >Find</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <div class="mb-20">Found: {{ data.length }}</div>
      <el-table
        border
        size="small"
        :data="displayData"
        :cell-class-name="cellClass"
        max-height="450"
      >
        <el-table-column
          label="Batch #"
          prop="batchNumber"
          width="65"
          fixed="left"
        ></el-table-column>
        <el-table-column label="SN" prop="sn" width="70"></el-table-column>
        <el-table-column
          label="Asset Number"
          prop="assetNumber"
        ></el-table-column>
        <el-table-column label="Version" width="100">
          <template slot-scope="scope">
            <div>HW:{{ scope.row.hwVersion }}</div>
            <div>FW:{{ scope.row.fwVersion }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Production Date" prop="startTime">
          <template slot-scope="scope">
            <div>
              {{ moment(scope.row.productionDate).format('DD/MM/YYYY') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="MAC ADD" prop="bleMac"></el-table-column>
        <el-table-column label="Tested By" prop="testerName"></el-table-column>
        <!-- <el-table-column label="Notes" prop="notes"></el-table-column> -->
        <el-table-column label="Result" prop="result">
          <template slot-scope="scope">
            <div>{{ scope.row.testType }} : {{ scope.row.result }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Action" fixed="right">
          <template slot-scope="scope">
            <span
              class="blue-font underline pointer"
              @click="showDetail(scope.row)"
              >VIEW DETAILS</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-10 text-right">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :total="data.length"
        >
        </el-pagination>
      </div>
    </div>
    <TestReportDetail ref="testReportDetail" />
  </div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'
import ApiService from '@/services/CommonApiService.js'
import TestReportDetail from '@/components/production/pod/TestReportDetail'
import { pass } from '../../../const'
export default {
  data() {
    return {
      pass: pass,
      moment,
      loading: false,
      form: {
        podMac: '',
        testedBy: '',
        hwVer: '',
        fwVer: '',
        date: [],
        result: 'ALL',
        assetNumber: ''
      },
      pods: [],
      testers: [],
      assetNumberOptions: [],
      hwVersion: [],
      fwVersion: [],
      testResultsOptions: ['ALL', 'PASS', 'FAIL'],
      timeChange: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      data: [], // all data
      page: 1,
      pageSize: 20
    }
  },
  components: {
    TestReportDetail
  },
  mounted() {
    this.getData(true)
  },
  computed: {
    // table data
    displayData() {
      if (!this.data || this.data.length === 0) return []
      return this.data.slice(
        this.pageSize * this.page - this.pageSize,
        this.pageSize * this.page
      )
    }
  },
  methods: {
    clearForm() {
      this.form = {
        podMac: '',
        testedBy: '',
        hwVer: '',
        fwVer: '',
        date: [],
        result: 'ALL',
        assetNumber: ''
      }
      this.getData()
    },
    cellClass(e) {
      if (e.column.property === 'result') {
        return e.row.result === this.pass ? 'light-green-bg' : 'light-red-bg'
      }
      return ''
    },
    getData(isInit = false) {
      this.loading = true
      this.page = 1
      ApiService.GetTestReports(this.form)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.fwVersion = response.data.data.fwVersion
            this.hwVersion = response.data.data.hwVersion
            this.testers = response.data.data.testers
            this.pods = response.data.data.pods
            this.data = response.data.data.all.map(item => {
              return {
                ...item,
                sn: item.bleMac.substring(item.bleMac.length - 6)
              }
            })
            if (isInit) {
              this.assetNumberOptions = response.data.data.assetNumbers.map(
                item => {
                  return {
                    value: item,
                    label: item || 'None'
                  }
                }
              )
            }
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    showDetail(row) {
      this.$refs.testReportDetail.openDialog(row.id)
      this.$refs.testReportDetail.printInfo.popTitle =
        row.testType + ' test report detail for ' + row.sn
    },
    handleCurrentChange(val) {
      this.page = val
    }
  }
}
</script>
